/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-inline-comments */
import React from 'react'
import PropTypes from 'prop-types'
import CssBaseline from '@material-ui/core/CssBaseline'
import { withStyles } from '@material-ui/core/styles'
import HelpOutline from '@material-ui/icons/HelpOutline'
import LeaderboardAv from '@material-ui/icons/ListAltSharp'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListSubheader from '@material-ui/core/ListSubheader'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Person from '@material-ui/icons/Person'
import IorgEval from '@material-ui/icons/GroupWorkTwoTone'
import IgenEval from '@material-ui/icons/GroupTwoTone'
import IorgStats from '@material-ui/icons/LibraryBooksSharp'
import IgenStats from '@material-ui/icons/ListTwoTone'
import LibraryBooks from '@material-ui/icons/LibraryBooks'
import SpeakerNotes from '@material-ui/icons/SpeakerNotes'
import PersonPin from '@material-ui/icons/PersonPin'
import PoeIcon from '@material-ui/icons/ContactsRounded'
import Videocam from '@material-ui/icons/Videocam'
import Mic from '@material-ui/icons/Mic'
import RemoveRedEye from '@material-ui/icons/RemoveRedEye'
import PeopleIcon from '@material-ui/icons/People'
import GroupIcon from '@material-ui/icons/GroupWork'
import ACUnitIcon from '@material-ui/icons/AcUnit'
import BusinessIcon from '@material-ui/icons/Business'
import ExitToApp from '@material-ui/icons/ExitToApp'
import Leaderb from '@material-ui/icons/BookOutlined'
import InsertChart from '@material-ui/icons/BrightnessHigh'
import IanalyticsChart from '@material-ui/icons/GraphicEqSharp'
import LeaderboardIcon from '@material-ui/icons/ListRounded'
// import ExecCLub from '@material-ui/icons/MoneySharp'
// import Trophy from "@material-ui/icons/alarm-light";
// import { Icon, InlineIcon } from '@iconify/react';
import EmojiEventsIcon from '@material-ui/icons/WbSunnyOutlined'
import pledgeIcon from '@material-ui/icons/CardGiftcard'
import AlisonIcon from '@material-ui/icons/StarHalfOutlined'
import BYUIcon from '@material-ui/icons/StarBorderRounded'
import MEvisionIcon from '@material-ui/icons/PersonSharp'
import PlaylistAddCheck from '@material-ui/icons/PlaylistAddCheck'
import Downloadapp from '@material-ui/icons/CloudDownload'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import DownloadNote from '../../store/actions/DownloadEXEnoteb'
// import LiveHelpIcon from '@material-ui/icons/LiveHelp'
// import CompetenciesManage from "../../components/categories/competenciesManage";
// import competenciesIcon from "@material-ui/icons/Accessible";
import Badge from '@material-ui/core/Badge'
import StarRoundedIcon from '@material-ui/icons/StarRounded'
import { connect } from 'react-redux'
import { signOut } from '../../store/actions/authActions'
import { signOutStrong, signOutDuplicate } from '../../store/actions/authActions'
import firebase from '../../store/firebase'
import axios from 'axios'
import { hideToast, showToast } from '../../store/actions/toastAction'
import {
  APP_TYPE,
  ACCESS_COMPANY_PROFILE_USER,
  IS_COMPANY_ADMIN,
  IS_COMPANY_ADMIN_MASTER,
  IS_SCHOOL_ADMIN,
  IS_ADMIN_SECTION,
  PUBLIC_COMPANY_ID, USER_CLICKS_SECTION,
  SHOW_SPEEDDIAL,
  LEADERBOARD_LOADING,
  GET_ALL_COMPANY_USERS,
  LEADERBOARD,
  FB_URL
} from '../../store/actions/types'

import {
  loadingAction
} from '../../store/actions/loadingAction'

import {
  captureUserActivity
} from '../../store/actions/analyticsActions'
import { showSpeedDial } from '../../store/actions/speedDialAction'
import {
  getAllCompanyLeaders
} from '../../store/actions/companyAdminActions'
import { DEEPORANGE } from '../../utils/color_utils'
import { Link } from 'react-router-dom'
import { isBrowser } from 'react-device-detect'
import ChatIcon from '@material-ui/icons/Chat'
import Exectext from './Exectext'
import Button from '@material-ui/core/Button'
import {
  CgetOpinions
} from '../../store/actions/opinionCActions'
import {
  GgetOpinions
} from '../../store/actions/opinionG_Actions'
import {
  getOpinions
} from '../../store/actions/opinionActions'
import { Tooltip } from '@mui/material';
import CryptoJS from "crypto-js";

const styles = () => ({
  root: {
    width: '100%',
    // backgroundColor: '#222d32',
    backgroundColor: '#ffffff', // '#000',
    color: '#ffffff' // '#fff'
  },
  inset: {
    paddingLeft: '12px'
  },
  listselected: {
    color: `${DEEPORANGE}`
  },
  drawer: {
    width: '280px'
  },
  subheader: {
    textTransform: 'upperCase',
    fontSize: '9pt',
    // color: '#fff',
    color: '#000000',
    fontWeight: 'bold',
    // boxShadow: '0px 0px 10px rgba(50,50,50,0.5)',
    // backgroundColor: '#2a2e37',
    backgroundColor: '#fff',
    lineHeight: '32px'
  },
  lsubheader: {
    textTransform: 'upperCase',
    fontSize: '9pt',
    // color: '#fff',
    color: '#000000',
    fontWeight: 'bold',
    // boxShadow: '0px 0px 10px rgba(50,50,50,0.5)',
    // backgroundColor: '#2a2e37',
    backgroundColor: '#fff',
    lineHeight: '32px',
    textDecoration: 'none'
    // a:link: { 'textDecoration': 'none' },
    // a:visited: { textDecoration: 'none' },
    // a:hover: { textDecoration: 'none' },
    // a:active: { textDecoration: 'none' }
  },
  listtext: {
    'fontSize': '10pt',
    // color: 'silver',
    'color': '#000',
    '&:hover, &.active:hover': {
      color: '#000000'
    }
  },
  listExec: {
    'fontSize': '10pt',
    // color: 'silver',
    'color': '#000000',
    '&:hover, &.active:hover': {
      color: '#000000'
    }
  },
  listitem: {
    'height': '50px',
    '&.active': {
      '& path': {
        color: 'red'
      }
    },
    '&:hover, &.active:hover': {
      '& path': {
        color: '#cccccc'
      }
    }
  },
  active: {
    backgroundColor: 'red',
    color: 'red'
  },
  iconBorder: {
    width: '35px!important',
    height: '35px!important',
    borderRadius: '50%',
    textAlign: 'center',
    backgroundColor: 'rgba(255,255,255,0.085)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'small'
  },
  menuIcons: {
    color: '#000',
    marginRight: '0',
    fontSize: 'small',
    minWidth: '0px!important'
  },
  badge: {
    backgroundColor: DEEPORANGE,
    padding: 2,
    borderRadius: 4
  },
  accordion: {
    // backgroundColor: '#2a2e37',
    backgroundColor: '#fff'
  },
  accordionItem: {
    width: '100%'
  },
  pulsatingLink: {
    animation: '$pulse 2s infinite ease-in-out',
    textDecoration: 'none',
    backgroundColor: 'none',
    paddingLeft: '3px',
    paddingRight: '8px',
    paddingTop: '0px',
    paddingBottom: '0px',
    marginTop: '0px',
    fontSize: '12px',
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
      opacity: 1,
      color: '#00008B', // Dark blue when smaller
    },
    '50%': {
      transform: 'scale(1.05)',
      opacity: 0.8,
      color: '#00B7EB', // Shiny/bright blue when larger
    },
    '100%': {
      transform: 'scale(1)',
      opacity: 1,
      color: '#00008B', // Back to dark blue
    },
  },
  column: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    width: '100%'
  }

})

class SideBar extends React.Component {
  state = {
    showDownloadNote: false,
    userinSession: this.props.userdata.uid ? this.props.userdata.uid : '',
    // loadingLeaders: false
  };

  loadLeaderboard = () => {
    // Hydrate quickly from cache if present, but always kick off a refresh
    try {
      const cachedUsers = localStorage.getItem('leaderboardUsers')
      const cachedData = localStorage.getItem('leaderboardData')
      const cachedAtStr = localStorage.getItem('leaderboardCacheAt')
      const TTL_MS = 10 * 60 * 1000
      const isFresh = cachedAtStr ? (Date.now() - Number(cachedAtStr)) < TTL_MS : false

      if (cachedUsers && cachedData) {
        this.props.dispatch({ type: GET_ALL_COMPANY_USERS, users: JSON.parse(cachedUsers) })
        this.props.dispatch({ type: LEADERBOARD, leaderboard_action: JSON.parse(cachedData) })
      }

      if (!cachedUsers || !cachedData || !isFresh) {
        if (this.props.userdata && this.props.userdata.companyID) {
          this.props.getAllCompanyLeaders({
            orderChild: 'LeaderboardKey',
            LeaderboardKey: 'x=x=x=x',
            companyID: this.props.userdata.companyID
          })
        }
      }
    } catch (_) {
      if (this.props.userdata && this.props.userdata.companyID) {
        this.props.getAllCompanyLeaders({
          orderChild: 'LeaderboardKey',
          LeaderboardKey: 'x=x=x=x',
          companyID: this.props.userdata.companyID
        })
      }
    }
  }
   ////Enforce session unique identity/////////////////////////////////////////////////////////////////////////////////
  generateSessionId = () => {
    return (
      Date.now().toString(36) +
      Math.random().toString(36).substring(2, 15)
    );
  };

  enforceSingleSession = (uid) => {
    return async (dispatch) => {
      //const uid = this.state.userinSession; //user.uid;
      console.log('enforceSingleSession enforceSingleSession 1', uid);

      try {
        // 1️⃣ Get current session value from database
        const snapshot = await firebase
          .database()
          .ref(`user/${uid}/uniqueSession`)
          .once("value");
        console.log('enforceSingleSession enforceSingleSession 2');

        const existingSession = snapshot.val();

        // 2️⃣ If session already exists → force logout
        if (existingSession && existingSession !== "") {
          console.log("Another active session detected. Signing out.");
          dispatch(signOutDuplicate());
          return;
        }

        // 3️⃣ Otherwise create new session
        const uniqueSession = generateSessionId();

        let updates = {};
        updates[`user/${uid}/uniqueSession`] = uniqueSession;

             var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                    params: {
                         updates: updates                    
                     }
                   })
 
               if (res.data || res.data.success === true) {
                 console.log('Successfully created new uniqueSession');               }
               else {
                 console.error('Error creating new uniqueSesssion:', error);
               };

        console.log("Session created:", uniqueSession);

        // Optional: store locally to verify later
        localStorage.setItem("uniqueSession", uniqueSession);

      } catch (error) {
        console.error("Session enforcement error:", error);
      }
    };
  };

   //////////////////////////////////////////////////////////////////////////////////////////
  
  // enforceSingleSession = async (uid) => {
  // console.log('enforceSingleSession enforceSingleSession 1', uid);

  // try {
  //   const snapshot = await firebase
  //     .database
  //     .ref(`user/${uid}/uniqueSession`)
  //     .once("value");

  //   console.log('enforceSingleSession enforceSingleSession 2');
  //   const existingSession = snapshot.val();

  //   // const uidaccount = snapshot.val();
  //   // const existingSession = uidaccount.uniqueSession;
  //   // const sessionCount = uidaccount.sessionCount;

  //   if (existingSession && existingSession !== "") {
  //     console.log("Another active session detected. Signing out.");
  //     this.props.dispatch(signOutDuplicate()); // UNCOMMENT FOR PROCESS TO WORK
  //     return;
  //   }

  //   const uniqueSession = this.generateSessionId();

  //   let updates = {};
  //   updates[`user/${uid}/uniqueSession`] = uniqueSession;
  //  // updates[`user/${uid}/sessionCount`] = sessionCount + 1;

  //   const res = await axios.post(`${FB_URL}/m115-freshcard`, {
  //     params: { updates }
  //   });

  //   if (res.data && res.data.success === true) {
  //     console.log('Successfully created new uniqueSession');
  //   }

  //   localStorage.setItem("uniqueSession", uniqueSession);

  // } catch (error) {
  //   console.error("Session enforcement error:", error);
  // }
  // };
  
componentDidMount() {
  const { userinSession } = this.state;

  // ────────────────────────────────────────────────
  //  Changed line – now dispatching the thunk properly
  if (userinSession) {
  //  this.props.dispatch(this.enforceSingleSession(userinSession));
  }
  // ────────────────────────────────────────────────

  if (this.props.userdata) {
    this.props.CgetOpinions({
      leaderID: this.props.userdata.companyID
    });
    this.props.GgetOpinions({
      leaderID: this.props.userdata.companyID
    });
    this.props.getOpinions({
      leaderID: this.props.userdata.userID
    });
  }
  // console.log('localStorage-user_logged_in 1: ', localStorage.getItem('user_logged_in'));
  // console.log('localStorage-user_logged_in 2: ', Object.keys(localStorage));
}

   componentDidMount_Mar62026() {
       const { userinSession } = this.state; // Adjust based on how you get userinSession
      // const COSIGNA = process.env.REACT_APP_COSIGNA;
      // const COSIGNC = process.env.REACT_APP_COSIGNC;

    // console.log('enforceSingleSession enforceSingleSession 0', userinSession);
     this.enforceSingleSession(userinSession);  //UNCOMMENT TO ENFORCE SESSION CODE

    if (this.props.userdata) {
      this.props.CgetOpinions({ // loads the opinions of leaders recorded in state
        leaderID: this.props.userdata.companyID
      })
      this.props.GgetOpinions({ // loads the opinions of leaders recorded in state
        leaderID: this.props.userdata.companyID
      })
      this.props.getOpinions({ // loads the opinions of leaders recorded in state
        leaderID: this.props.userdata.userID
      })
    }
  }

////////////////////////////////////////////////////////////////////////////////////
// ──────────────────────────────
//  decryptUID 
// ──────────────────────────────
decryptUID(cipherText) {
  const AES_KEY = "4f9c1fa7ec2f4832973c0f5d2f43b7cc";
  const AES_IV  = "7f4d3b92c3a04f8dac5c59cbf1a4d87f";

  // Fix: Convert URL-safe Base64 → standard Base64
  cipherText = cipherText.replace(/-/g, '+').replace(/_/g, '/');

  const key = CryptoJS.enc.Hex.parse(AES_KEY);
  const iv  = CryptoJS.enc.Hex.parse(AES_IV);

  const cipherParams = {
    ciphertext: CryptoJS.enc.Base64.parse(cipherText)
  };

  const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}
/////////////////////////////////////////////////////////////////////////////////////

  setDownload = () => {
   // this.setState({ showDownloadNote: true })
  }

  loadCompetencies = () => {
    this.setState({ showCompmenu: true })
  }

  toggleDrawer = (page) => {
    let params2 = {
      userdata: this.props.userdata,
      type: USER_CLICKS_SECTION,
      page
    }

    this.props.captureUserActivity({ ...params2 })
    this.props.toggleDrawer()

    let body = {
      type: SHOW_SPEEDDIAL,
      path: page
    }
    this.props.showSpeedDial(body)
  };

  render() {
    const {
      classes,
      unseenotifications,
      unseengroupnotifications,
      unseenpldpnotifications,
      userdata,
      loadingLBLeaders
    } = this.props
    const {userinSession} = this.state;

    console.log("envTest: ENV VALUE = ", process.env.REACT_APP_COSIGNA);
    console.log("envTest: TYPE = ", typeof process.env.REACT_APP_COSIGNA);
    
    const COSIGNA = this.decryptUID(process.env.REACT_APP_COSIGNA);
    const COSIGNC = this.decryptUID(process.env.REACT_APP_COSIGNC);

    console.log("envTest: COSIGNA", COSIGNA);

    var cosignAdmin = false;
    if (userinSession === COSIGNA || userinSession === COSIGNC ) { cosignAdmin = true }
    // Check if leaderboard data is available (either in Redux or localStorage)
    const hasLeaderboardData = () => {
      // First check Redux state
      if (this.props.leaderboardData && Object.keys(this.props.leaderboardData).length > 0) {
        return true;
      }
      
      // Then check localStorage cache
      try {
        const cachedUsers = localStorage.getItem('leaderboardUsers');
        const cachedData = localStorage.getItem('leaderboardData');
        return !!(cachedUsers && cachedData);
      } catch (error) {
        return false;
      }
    };

    var path = window.location.pathname;
    var page = path.split("/").pop();
    if (this.props.userdata) {
      }
    var totalLeadershipConversationNotifications = 0;
    if (unseengroupnotifications.unseengroupnotificationscnt || 
    unseenotifications.ileadcorporate) {
        totalLeadershipConversationNotifications = unseengroupnotifications.unseengroupnotificationscnt + unseenotifications.ileadcorporate
    }
    else
    {
      totalLeadershipConversationNotifications = 0
    }
    const totalLibraryNotifications = unseenotifications.topleaderthoughts + unseenotifications.dailythoughts
    const totalPLFPNotifications = unseenpldpnotifications.pldpnotifications

    const drawer = (
      <div>
        { userdata && (((userdata.companyID === '-KgsUcgfo7z1U9MXgd9i') ||
      (userdata.companyID === '-LjW7UI7e0uUikYrw-Vj') ||
      (userdata.companyID === '-MXbWQy6QoZ4RfN04pXe') ||
      (userdata.companyID === '-MRZC7xU_69moSco5_sX') ||
      (userdata.companyID === '-MZwJp46RoDtehNEGly3') ||
      (userdata.companyID === '-MHRD2gH8B-4umEza1eG') ||
      (userdata.companyID === '-Mci2tVbY406VWKWa5Ov') ||
      (userdata.companyID === '-LoacuJOqQP7sZU7_sFQ') ||
      (userdata.companyID === '-MwlTcmm_zvbLlRqmJP3') ||
      (userdata.companyID === '-MxtPrQQGFMGUZOcl_QZ') ||
      (userdata.companyID === '-N3xp_AnYTDW_vLIB6h3') ||
      (userdata.companyID === '-NG0pAn_r4HUmzGjwhH4') ||
      (userdata.companyID === '-NTUaz-CD0gKI2jagykx') ||
      (userdata.companyID === '-NV-bhSOa3T8iQKaYMNZ') ||
      (userdata.companyID === '-NVZ5YC5BVUhSb-BhyX7') ||
      (userdata.companyID === '-NRbTwxbqFLepk62Eq6M') ||
      (userdata.companyID === '-O8Bfv5hul2K2mP-sFAx') ||
      (userdata.companyID === '-O8zuS3x_myK-f5NfVyO')
        )) ?
          // <List>
          //   <ListItem
          //     className={classes.listitem}
          //     component={Link}
          //     to='/gotocalf'
          //     button
          //     onClick={() => {
          //       this.toggleDrawer('gotocalf')
          //     }}
          //   >
          //     <div className={classes.iconBorder}>
          //       <ListItemIcon classes={{ root: classes.menuIcons }}>
          //         <InsertChart />
          //       </ListItemIcon>
          //     </div>
          //     <ListItemText
          //       classes={{ primary: classes.listtext, inset: classes.inset }}
          //       inset
          //       primary={this.props.userdata.execmember ? 'Executive Club' : <Exectext />}
          //     />
          //   </ListItem>
          // </List>
          <div>

          {/* PATREON//////////////////////////////////////////////////////////////////////// */}
          {/* { userdata ?  //userdata && (userdata.patron !== true) ? */}
           {/* { userdata && (userdata.patron !== true) ?
            <List>
            <Link
              style={{ textDecoration: 'none' }}
              to={{
                pathname: '/gotopatreon',
              }}
              onClick={() => {
                this.toggleDrawer('gotopatreon')
              }}
            >
              <Badge>
              <Typography className={classes.lsubheader}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Confirm Pledge</Typography> 
              </Badge>
            </Link>
          </List>
          : null} */}
          {/* /////////////////////////////////////////////////////////////////////////////////////// */}
          { userdata && (userdata.patron !== true) ?
            <List>
            <ListItem className={classes.listitem}>
              <Tooltip title="Get 25% of your pledge in MEV crypto + unlock earning features." arrow>
                <a
                  target="main"
                  href="https://www.patreon.com/mevision"
                  className={classes.pulsatingLink}
                  style={{
                    border: '1px solid orange',
                    borderRadius: '4px',
                    padding: '4px 8px',
                    textDecoration: 'none',
                    display: 'inline-block'
                  }}
                >
                  <b>POWER YOUR ACCOUNT WITH PATREON</b>
                </a>
              </Tooltip>
              <ListItemText classes={{ primary: classes.listtext, inset: classes.inset }} />
            </ListItem>
          </List>
          : null}
          {/* //////PATREON END LINKS///////////////////////////////////////////////////////////////////////////////// */}
          {/* <List>
            <Link
              style={{ textDecoration: 'none' }}
              to={{
                pathname: '/gotocalf',
                // state: {
                //   Everyone: 'xx=x=x=x'
                // }
              }}
              onClick={() => {
                this.toggleDrawer('gotocalf')
              }}
            >
              <Badge>
              <Typography className={classes.lsubheader}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Learning Platform</Typography> 
              </Badge>
            </Link>
          </List> */}
          </div>
          : null}
        {/* LEADERBOARD ------------------------------------*/}
        {/* {IS_COMPANY_ADMIN[this.props.userdata.userType] && ( */}
          {IS_COMPANY_ADMIN[this.props.userdata.userType] &&
            this.props.userdata.userType !== 21 && (
          // <List>
          //   {hasLeaderboardData() ? (
          //     <Link
          //       style={{ textDecoration: 'none' }}
          //       to={{
          //         pathname: '/LeaderOnList',
          //         state: { Everyone: 'xx=x=x=x' }
          //       }}
          //       onClick={() => this.toggleDrawer('leaderOnList')}
          //     >
          //       <Badge>
          //         <Typography className={classes.lsubheader}>
          //           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Leader-track
          //         </Typography>
          //       </Badge>
          //     </Link>
          //   ) : (
          //     <Button
          //       size="small"
          //       type="button"
          //       component={Link}
          //       to="/LeaderOnList"
          //       onClick={() => this.loadLeaderboard()}
          //     >
          //       <Badge>
          //         <Typography className={classes.lsubheader}>
          //           &nbsp;&nbsp;&nbsp;&nbsp;Leader-track
          //         </Typography>
          //       </Badge>
          //     </Button>
          //   )}
          // </List>


               <List>
                 <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/MyCertificates'
                        button
                        onClick={()=> {
                          this.toggleDrawer('MyCertificates')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <Leaderb />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='Leaderboard'
                        />
                      </ListItem>  
                       </List>
       
        )}
        
        {/* CALF APP ---------------------------------------*/}
        {/* Seamless Certificate -actionSA--------------------------------------*/}
        { userdata && userdata.companyID === '-MHRD2gH8B-4umEza1eG' ?
          <List>
            <ListItem
              className={classes.listitem}
            >
              <div className={classes.iconBorder}>
                <ListItemIcon classes={{ root: classes.menuIcons }}>
                  <EmojiEventsIcon />
                </ListItemIcon>
              </div>
              <a target='main' href='https://www.actionsa.org.za/certify/'
                style={{
                  textDecoration: 'none', color: '#000000',
                  backgroundColor: 'none', paddingLeft: '12px',
                  paddingRight: '8px', paddingTop: '8px', paddingBottom: '15px',
                  marginTop: '10px'
                }}>Action-Leadership Cert.
              </a>
              <ListItemText
                classes={{ primary: classes.listtext, inset: classes.inset }}
              />
            </ListItem>
          </List>
          : null}

        {/* Seamless Certificate -leadership platform--------------------------------------*/}
                {/* Alison  -------------------------------------*/}
                {/* { userdata && userdata.execmember ?
          <List>
            <ListItem
              className={classes.listitem}
            >
              <div className={classes.iconBorder}>
                <ListItemIcon classes={{ root: classes.menuIcons }}>
                  <EmojiEventsIcon />
                </ListItemIcon>
              </div>
              <a target='main' href='https://alison.com/?utm_source=alison_user&utm_medium=affiliates&utm_campaign=30620902'
                style={{
                  textDecoration: 'none', color: '#000000',
                  backgroundColor: 'none', paddingLeft: '12px',
                  paddingRight: '8px', paddingTop: '8px', paddingBottom: '15px',
                  marginTop: '10px'
                }}>Online Learning
              </a>
              <ListItemText
                classes={{ primary: classes.listtext, inset: classes.inset }}
              />
            </ListItem>
          </List>
          : null} */}

        {/* Alison--------------------------------------*/}
        { userdata && (userdata.companyID === '-KgsUcgfo7z1U9MXgd9i') ?
          <List>
            <Badge>
              <Typography className={classes.lsubheader}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a target='main' href='https://bit.ly/37fEG32'
                style={{ textDecoration: 'none', color: '#000000' }}>
                Seamless Leadership Certificate</a></Typography>
            </Badge>

          </List>
          // <List>
          //   <ListItem
          //     className={classes.listitem}
          //   >
          //     <div className={classes.iconBorder}>
          //       <ListItemIcon classes={{ root: classes.menuIcons }}>
          //         <EmojiEventsIcon />
          //       </ListItemIcon>
          //     </div>
          //     <a target='main' href='https://bit.ly/37fEG32'
          //       style={{
          //         textDecoration: 'none', color: '#000000',
          //         backgroundColor: 'none', paddingLeft: '12px',
          //         paddingRight: '8px', paddingTop: '8px', paddingBottom: '15px',
          //         marginTop: '10px'
          //       }}>Seamless Leadership Certificate
          //     </a>
          //     <ListItemText
          //       classes={{ primary: classes.listtext, inset: classes.inset }}
          //     />
          //   </ListItem>
          // </List>
          : null}

        {/* GLI APP ---------------------------------------*/}
        { userdata && userdata.companyID === '-LoacuJOqQP7sZU7_sFQ' ?
          <List>
            <ListItem
              className={classes.listitem}
            >
              <div className={classes.iconBorder}>
                <ListItemIcon classes={{ root: classes.menuIcons }}>
                  <InsertChart />
                </ListItemIcon>
              </div>
              <a target='main' href='https://global-leadership-initiatives-inc.teachable.com/'
                style={{
                  textDecoration: 'none', color: 'white',
                  backgroundColor: 'none', paddingLeft: '12px',
                  paddingRight: '8px', paddingTop: '8px', paddingBottom: '15px',
                  marginTop: '10px'
                }}>GLI Leadership Courses
              </a>
              <ListItemText
                classes={{ primary: classes.listtext, inset: classes.inset }}
              />
            </ListItem>
          </List>
          : null}

        <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: ' #ccbc74' }} />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <Badge
              invisible={
                totalLeadershipConversationNotifications > 0 ? false : true
              }
              badgeContent={
                <span className={classes.badge}>
                  {totalLeadershipConversationNotifications}
                </span>
              }
            >
              <Typography className={classes.subheader}>LEAD Conversations</Typography>
            </Badge>

          </AccordionSummary>
          <AccordionDetails>
            <div className={classes.column}>
              <div className={classes.accordionItem}>
                {APP_TYPE !== 'PUBLIC' ? (
                  <div>
                    {/* {userdata && userdata.companyID === '-Lu4BlhZ-tsDSnd-fnFd' ? (
                      <span>
                        <ListItem
                          classes={{
                            root: classes.listitem,
                            selected: classes.listselected
                          }}
                          exact
                          component={Link}
                          to='/groupmessages'
                          button
                          onClick={() => {
                            this.toggleDrawer('groupmessages')
                          }}
                        >
                          <div className={classes.iconBorder}>
                            <ListItemIcon classes={{ root: classes.menuIcons }}>
                              <Badge
                                invisible={
                                  unseengroupnotifications.unseengroupnotificationscnt > 0 ? false : true
                                }
                                badgeContent={
                                  <span className={classes.badge}>
                                    {unseengroupnotifications.unseengroupnotificationscnt}
                                  </span>
                                }
                              >
                                <GroupIcon />
                              </Badge>
                            </ListItemIcon>
                          </div>
                          <ListItemText
                            classes={{ primary: classes.listtext, inset: classes.inset }}
                            inset
                            primary='Group Forums'
                          />
                        </ListItem>
                        <ListItem
                          classes={{
                            root: classes.listitem,
                            selected: classes.listselected
                          }}
                          exact
                          component={Link}
                          to='/organisational'
                          button
                          onClick={() => {
                            this.toggleDrawer('organisational')
                          }}
                        >
                          <div className={classes.iconBorder}>
                            <ListItemIcon classes={{ root: classes.menuIcons }}>
                              <Badge
                                invisible={
                                  unseenotifications.companythoughts > 0 ? false : true
                                }
                                badgeContent={
                                  <span className={classes.badge}>
                                    {unseenotifications.companythoughts}
                                  </span>
                                }
                              >
                                <BusinessIcon />
                              </Badge>
                            </ListItemIcon>
                          </div>
                          <ListItemText
                            classes={{ primary: classes.listtext, inset: classes.inset }}
                            inset
                            primary='Club Forum'
                          />
                        </ListItem>
                      </span>
                    ) : ( */}
                    <span>
                      {userdata && userdata.companyID === '-LjW7UI7e0uUikYrw-Vj' ? (<div/>) : (
                        <ListItem
                          classes={{
                            root: classes.listitem,
                            selected: classes.listselected
                          }}
                          exact
                          component={Link}
                          to='/organisational'
                          button
                          onClick={() => {
                            this.toggleDrawer('organisational')
                          }}
                        >
                          <div className={classes.iconBorder}>
                            <ListItemIcon classes={{ root: classes.menuIcons }}>
                              <Badge
                                invisible={
                                  unseenotifications.companythoughts > 0 ? false : true
                                }
                                badgeContent={
                                  <span className={classes.badge}>
                                    {unseenotifications.companythoughts}
                                  </span>
                                }
                              >
                                <BusinessIcon />
                              </Badge>
                            </ListItemIcon>
                          </div>
                          <ListItemText
                            classes={{ primary: classes.listtext, inset: classes.inset }}
                            inset
                            primary=' nnnn'
                          />
                        </ListItem>
                      )}

                      <ListItem
                        classes={{
                          root: classes.listitem,
                          selected: classes.listselected
                        }}
                        exact
                        component={Link}
                        to='/groupmessages'
                        button
                        onClick={() => {
                          this.toggleDrawer('groupmessages')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <Badge
                              invisible={
                                unseengroupnotifications.unseengroupnotificationscnt > 0 ? false : true
                              }
                              badgeContent={
                                <span className={classes.badge}>
                                  {unseengroupnotifications.unseengroupnotificationscnt}
                                </span>
                              }
                            >
                              <GroupIcon />
                            </Badge>
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='Group Forums'
                        />
                      </ListItem>
                    </span>


                    {userdata && userdata.companyID === '-Lu4BlhZ-tsDSnd-fnFd' ? (null) : (
                      <ListItem
                        className={classes.listitem}
                        component={Link}
                        to={page==='ilead' ? '/ilead' : '/ilead'}
                        onClick={() => {
                          var npage;
                          if (page==='ilead') {npage = '/'} else {npage = '/ilead'}
                          this.toggleDrawer(npage)
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <Badge
                              invisible={
                                unseenotifications.ileadcorporate > 0 ? false : true
                              }
                              badgeContent={
                                <span className={classes.badge}>
                                  {unseenotifications.ileadcorporate}
                                </span>
                              }
                            >
                              <ACUnitIcon />
                            </Badge>
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='Global Forum'
                        />
                      </ListItem>
                    )}

                  </div>
                ) : userdata ? (
                  <div>
                    {/* {userdata.companyID === '-Lu4BlhZ-tsDSnd-fnFd' ? (
                      <span>
                        <ListItem
                          classes={{
                            root: classes.listitem,
                            selected: classes.listselected
                          }}
                          exact
                          component={Link}
                          to='/groupmessages'
                          button
                          onClick={() => {
                            this.toggleDrawer('groupmessages')
                          }}
                        >
                          <div className={classes.iconBorder}>
                            <ListItemIcon classes={{ root: classes.menuIcons }}>
                              <Badge
                                invisible={
                                  unseengroupnotifications.unseengroupnotificationscnt > 0 ? false : true
                                }
                                badgeContent={
                                  <span className={classes.badge}>
                                    {unseengroupnotifications.unseengroupnotificationscnt}
                                  </span>
                                }
                              >
                                <GroupIcon />
                              </Badge>
                            </ListItemIcon>
                          </div>
                          <ListItemText
                            classes={{ primary: classes.listtext, inset: classes.inset }}
                            inset
                            primary='Group Forums'
                          />
                        </ListItem>
                        <ListItem
                          classes={{
                            root: classes.listitem,
                            selected: classes.listselected
                          }}
                          exact
                          component={Link}
                          to='/organisational'
                          button
                          onClick={()=> {
                            this.toggleDrawer('organisational')
                          }}
                        >
                          <div className={classes.iconBorder}>
                            <ListItemIcon classes={{ root: classes.menuIcons }}>
                              <Badge
                                invisible={
                                  unseenotifications.companythoughts > 0 ? false : true
                                }
                                badgeContent={
                                  <span className={classes.badge}>
                                    {unseenotifications.companythoughts}
                                  </span>
                                }
                              >
                                <BusinessIcon />
                              </Badge>
                            </ListItemIcon>
                          </div>
                          <ListItemText
                            classes={{ primary: classes.listtext, inset: classes.inset }}
                            inset
                            primary='Club Forum'
                          />
                        </ListItem>
                      </span>
                    ) :  */}

                    {userdata && userdata.companyID === '-LjW7UI7e0uUikYrw-Vj' ? (<div/>) : (
                      <span>
                        <ListItem
                          classes={{
                            root: classes.listitem,
                            selected: classes.listselected
                          }}
                          exact
                          component={Link}
                          to='/organisational'
                          button
                          onClick={()=> {
                            this.toggleDrawer('organisational')
                          }}
                        >
                          <div className={classes.iconBorder}>
                            <ListItemIcon classes={{ root: classes.menuIcons }}>
                              <Badge
                                invisible={
                                  unseenotifications.companythoughts > 0 ? false : true
                                }
                                badgeContent={
                                  <span className={classes.badge}>
                                    {unseenotifications.companythoughts}
                                  </span>
                                }
                              >
                                <BusinessIcon />
                              </Badge>
                            </ListItemIcon>
                          </div>
                          <ListItemText
                            classes={{ primary: classes.listtext, inset: classes.inset }}
                            inset
                            primary='Local Forum'
                          />
                        </ListItem>
                      </span>
                    )}

                    <span>
                      <ListItem
                        classes={{
                          root: classes.listitem,
                          selected: classes.listselected
                        }}
                        exact
                        component={Link}
                        to='/groupmessages'
                        button
                        onClick={()=> {
                          this.toggleDrawer('groupmessages')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <Badge
                              invisible={
                                unseengroupnotifications.unseengroupnotificationscnt > 0 ? false : true
                              }
                              badgeContent={
                                <span className={classes.badge}>
                                  {unseengroupnotifications.unseengroupnotificationscnt}
                                </span>
                              }
                            >
                              <GroupIcon />
                            </Badge>
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='Group Forums'
                        />
                      </ListItem>
                    </span>
                    <ListItem
                      className={classes.listitem}
                      component={Link}
                      to={page==='ilead' ? '/' : '/ilead'}
                      button
                      onClick={()=> {
                        //this.toggleDrawer('ilead')
                        var npage;
                        if (page==='ilead') {npage = '/'} else {npage = '/ilead'}
                        this.toggleDrawer(npage)
                      }}
                    >
                      <div className={classes.iconBorder}>
                        <ListItemIcon classes={{ root: classes.menuIcons }}>
                          <Badge
                            invisible={
                              unseenotifications.ileadpublic > 0 ? false : true
                            }
                            badgeContent={
                              <span className={classes.badge}>
                                {unseenotifications.ileadpublic}
                              </span>
                            }
                          >
                            <ACUnitIcon />
                          </Badge>
                        </ListItemIcon>
                      </div>
                      <ListItemText
                        classes={{ primary: classes.listtext, inset: classes.inset }}
                        inset
                        primary='Global Forum'
                      />
                    </ListItem>
                  </div>
                ) : <ListItem
                  className={classes.listitem}
                  component={Link}
                  to={page==='ilead' ? '/' : '/ilead'}
                  button
                  onClick={()=> {
                   // this.toggleDrawer('ilead')
                   var npage;
                   if (page==='ilead') {npage = '/'} else {npage = '/ilead'}
                   this.toggleDrawer(npage)
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <Badge
                        invisible={
                          unseenotifications.ileadpublic > 0 ? false : true
                        }
                        badgeContent={
                          <span className={classes.badge}>
                            {unseenotifications.ileadpublic}
                          </span>
                        }
                      >
                        <ACUnitIcon />
                      </Badge>
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Global Forum'
                  />
                </ListItem>                             
                }

                {/* <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/ThoughtsCard'
                  button
                  onClick={()=> {
                    this.toggleDrawer('ThoughtsCard')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <PlaylistAddCheck />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='ThoughtsCard'
                  />
                </ListItem> */}

              </div>
              <br />
              <div className={classes.accordionItem}>
                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/myposts'
                  button
                  onClick={()=> {
                    this.toggleDrawer('myposts')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <PersonPin />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='My LEADS'
                  />
                </ListItem>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        {this.props.userdata && this.props.userdata.companyID === '-Lu4BlhZ-tsDSnd-fnFd' ? (<List
          component='nav'
          subheader={
            <ListSubheader className={classes.subheader} component='div'>
      Harmony Practical Case Studies
            </ListSubheader>
          }
          className={classes.root}
        />) : (
          null
        )}


        {userdata && ['-LgsUykfo8z1U9MXgd9'].includes(this.props.userdata.companyID) ? (null) : (
          <Accordion className={classes.accordion}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#ccbc74' }} />}
              aria-controls='panel1a-content'
              id='panel1a-header'
            >
              <Badge
                invisible={
                  totalPLFPNotifications > 0 ? false : true
                }
                badgeContent={
                  <span className={classes.badge}>
                    {totalPLFPNotifications}
                  </span>
                }
              >
                <Typography className={classes.subheader}>Personal Development</Typography>
              </Badge>

            </AccordionSummary>
            <AccordionDetails>
              <div className={classes.column}>
                {/* <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/pldp'
                  button
                  onClick={()=> {
                    this.toggleDrawer('pldp')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <Badge
                        invisible={
                          unseenpldpnotifications.pldpnotifications > 0 ? false : true
                        }
                        badgeContent={
                          <span className={classes.badge}>
                            {unseenpldpnotifications.pldpnotifications}
                          </span>
                        }
                      >
                        <LibraryBooks />
                      </Badge>
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Personal Development Plan' // primary="Personal (LDP)"
                  />
                </ListItem> */}

                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/AgentDashboard'
                  button
                  onClick={()=> {
                    this.toggleDrawer('AgentDashboard')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <PlaylistAddCheck />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Development Partners'
                  />
                </ListItem>

                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/my-tests'
                  button
                  onClick={()=> {
                    this.toggleDrawer('my-tests')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <PlaylistAddCheck />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='My Resume'
                  />
                </ListItem>

          {/* Me-Vision--------------------------------------*/}
          { userdata ?

            <ListItem
              className={classes.listitem}
            >
            <div className={classes.iconBorder}>
            <ListItemIcon classes={{ root: classes.menuIcons }}>
              <MEvisionIcon />
            </ListItemIcon>
            </div>
            <a target='main' href='https://www.mevisionacademy.com'
            style={{
              textDecoration: 'none', color: '#000000',
              backgroundColor: 'none', paddingLeft: '12px',
              paddingRight: '8px', paddingTop: '8px', paddingBottom: '15px',
              marginTop: '10px', fontSize: '13px'
            }}>Me-Vision Academy
            </a>
            <ListItemText
            classes={{ primary: classes.listtext, inset: classes.inset }}
            />
            </ListItem>
            : null} 

                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/favourites'
                  button
                  onClick={()=> {
                    this.toggleDrawer('pldp')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>

                      <StarRoundedIcon />

                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Favourites' // primary="Personal (LDP)"
                  />
                </ListItem>

                {/* Alison  -------------------------------------*/}
         {/* { userdata && userdata.execmember ? */}
         { userdata ?
          <List>
            <ListItem
              className={classes.listitem}
            >
              <div className={classes.iconBorder}>
                <ListItemIcon classes={{ root: classes.menuIcons }}>
                  <AlisonIcon />
                </ListItemIcon>
              </div>
              <a target='main' href='https://alison.com/?utm_source=alison_user&utm_medium=affiliates&utm_campaign=30620902'
                style={{
                  textDecoration: 'none', color: '#000000',
                  backgroundColor: 'none', paddingLeft: '12px',
                  paddingRight: '8px', paddingTop: '8px', paddingBottom: '15px',
                  marginTop: '10px', fontSize: '13px'
                }}>Certificates and Diplomas
              </a>
              <ListItemText
                classes={{ primary: classes.listtext, inset: classes.inset }}
              />
            </ListItem>
          </List>
          : null} 

        {/* Alison--------------------------------------*/}
        { userdata ?
          <List>
            <ListItem
              className={classes.listitem}
            >
              <div className={classes.iconBorder}>
                <ListItemIcon classes={{ root: classes.menuIcons }}>
                  <BYUIcon />
                </ListItemIcon>
              </div>
              <a target='main' href='https://www.byupathway.org/applynow'
                style={{
                  textDecoration: 'none', color: '#000000',
                  backgroundColor: 'none', paddingLeft: '12px',
                  paddingRight: '8px', paddingTop: '8px', paddingBottom: '15px',
                  marginTop: '10px', fontSize: '13px'
                }}>International Degrees
              </a>
              <ListItemText
                classes={{ primary: classes.listtext, inset: classes.inset }}
              />
            </ListItem>
          </List>
          : null} 

        {/* Alison--------------------------------------*/}
                {/* <ListItem
                  className={classes.listitem}
                  // component={Link}
                  // to='https://firebasestorage.googleapis.com/v0/b/leadershipplatform-158316.appspot.com/o/files%2FPoints%20template.docx?alt=media&token=20d1b269-9da4-4732-a6d6-976e7ed8fb12'
                  button
                  onClick={()=> {
                    this.toggleDrawer('pldp')
                    window.open('https://firebasestorage.googleapis.com/v0/b/leadershipplatform-158316.appspot.com/o/files%2FReport%20Template%203.docx?alt=media&token=01d260a7-74aa-43d6-b0d4-fed22e4d9328')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <LiveHelpIcon />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Generate Points' // primary="Personal (LDP)"
                  />
                </ListItem> */}

              </div>
            </AccordionDetails>
          </Accordion>
        )}

{/* <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: '#ccbc74' }} />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >

            <Badge
              invisible={
                totalLibraryNotifications > 0 ? false : true
              }
              badgeContent={
                <span className={classes.badge}>
                  {totalLibraryNotifications}
                </span>
              }
            >
              <Typography className={classes.subheader}>LIBRARY
              </Typography>
            </Badge>
          </AccordionSummary>
          <AccordionDetails>
            <div className={classes.column}>
              {userdata && userdata.companyID === '-Lu4BlhZ-tsDSnd-fnFd' ? (null) : (
                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/globalcontributors'
                  button
                  onClick={()=> {
                    this.toggleDrawer('globalcontributors')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <Badge
                        invisible={
                          unseenotifications.topleaderthoughts > 0 ? false : true
                        }
                        badgeContent={
                          <span className={classes.badge}>
                            {unseenotifications.topleaderthoughts}
                          </span>
                        }
                      >
                        <PeopleIcon />
                      </Badge>
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Global Contributors'
                  />
                </ListItem>
              )
              }

              <ListItem
                    className={classes.listitem}
                    component={Link}
                    to="/Bookshop"
                    button
                    onClick={e => { this.toggleDrawer("bookshop") }}
                  >
                    <div className={classes.iconBorder}>
                      <ListItemIcon classes={{ root: classes.menuIcons }}>
                        <LibraryBooks />
                      </ListItemIcon>
                    </div>
                    <ListItemText
                      classes={{ primary: classes.listtext, inset: classes.inset }}
                      inset
                      primary="Bookshop"
                    />
                  </ListItem> 

              <ListItem
                className={classes.listitem}
                component={Link}
                to='/videos'
                button
                onClick={()=> {
                  this.toggleDrawer('videos')
                }}
              >
                <div className={classes.iconBorder}>
                  <ListItemIcon classes={{ root: classes.menuIcons }}>
                    <Badge
                      invisible={unseenotifications.videos > 0 ? false : true}
                      badgeContent={
                        <span className={classes.badge}>
                          {unseenotifications.videos}
                        </span>
                      }
                    >
                      <Videocam />
                    </Badge>
                  </ListItemIcon>
                </div>
                <ListItemText
                  classes={{ primary: classes.listtext, inset: classes.inset }}
                  inset
                  primary='Videos'
                />
              </ListItem>
              <ListItem
                className={classes.listitem}
                component={Link}
                to='/podcasts'
                button
                onClick={()=> {
                  this.toggleDrawer('podcasts')
                }}
              >
                <div className={classes.iconBorder}>
                  <ListItemIcon classes={{ root: classes.menuIcons }}>
                    <Badge
                      invisible={unseenotifications.podcasts > 0 ? false : true}
                      badgeContent={
                        <span className={classes.badge}>
                          {unseenotifications.podcasts}
                        </span>
                      }
                    >
                      <Mic />
                    </Badge>
                  </ListItemIcon>
                </div>
                <ListItemText
                  classes={{ primary: classes.listtext, inset: classes.inset }}
                  inset
                  primary='Podcasts & Audios'
                />
              </ListItem>
              <ListItem
                className={classes.listitem}
                component={Link}
                to='/articles'
                button
                onClick={()=> {
                  this.toggleDrawer('articles')
                }}
              >
                <div className={classes.iconBorder}>
                  <ListItemIcon classes={{ root: classes.menuIcons }}>
                    <Badge
                      invisible={unseenotifications.articles > 0 ? false : true}
                      badgeContent={
                        <span className={classes.badge}>
                          {unseenotifications.articles}
                        </span>
                      }
                    >
                      <RemoveRedEye />
                    </Badge>
                  </ListItemIcon>
                </div>
                <ListItemText
                  classes={{ primary: classes.listtext, inset: classes.inset }}
                  inset
                  primary='Articles'
                />
              </ListItem>

            </div>
          </AccordionDetails>
        </Accordion> */}

        {/* <React.Fragment>
          <Accordion className={classes.accordion}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#ccbc74' }} />}
              aria-controls='panel1a-content'
              id='panel1a-header'
            >
              <Typography className={classes.subheader}>RATE COLLECTIVE LEADERSHIP</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className={classes.column}>

                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/genEval'
                  button
                  onClick={()=> {
                    this.toggleDrawer('genEval')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <IgenEval />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Collective Assessment'
                  />
                </ListItem>

                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/genStats'
                  button
                  onClick={()=> {
                    this.toggleDrawer('genStats')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <IgenStats />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Collective Assessment Results'
                  />
                </ListItem>
              </div>
            </AccordionDetails>
          </Accordion>
        </React.Fragment> */}
{/* //PARTNERS//////////////////////////////////////////////////////////////////////////////// */}
{/* <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: '#ccbc74' }} />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <Typography className={classes.subheader}>Partners</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className={classes.column}>
              <ListItem
                className={classes.listitem}
                component={Link}
                to='/individuals'
                button
                onClick={()=> {
                  this.toggleDrawer('individuals')
                }}
              >
                <div className={classes.iconBorder}>
                  <ListItemIcon classes={{ root: classes.menuIcons }}>
                    <Person />
                  </ListItemIcon>
                </div>
                <ListItemText
                  classes={{ primary: classes.listtext, inset: classes.inset }}
                  inset
                  primary='Individuals'
                />
              </ListItem>
              <ListItem
                className={classes.listitem}
                component={Link}
                to='/organizations'
                button
                onClick={()=> {
                  this.toggleDrawer('organizations')
                }}
              >
                <div className={classes.iconBorder}>
                  <ListItemIcon classes={{ root: classes.menuIcons }}>
                    <BusinessIcon />
                  </ListItemIcon>
                </div>
                <ListItemText
                  classes={{ primary: classes.listtext, inset: classes.inset }}
                  inset
                  primary='Organisations'
                />
              </ListItem>
            </div>
          </AccordionDetails>
        </Accordion> */}
{/* //PARTNERS////////////////////////////////////////////////////////////////////////////////         */}
        {/* { this.props.userdata && ACCESS_COMPANY_PROFILE_USER[this.props.userdata.userType] ? ( */}
             {this.props.userdata &&
              IS_ADMIN_SECTION[this.props.userdata.userType] ? (
          <React.Fragment>
            <Accordion className={classes.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon style={{ color: '#ccbc74' }} />}
                aria-controls='panel1a-content'
                id='panel1a-header'
              >
                <Typography className={classes.subheader}>ADMIN</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className={classes.column}>
               {/* ///ADITIONAL STATS AND SURVEYS/////////////////////////  */}
                  {/* <ListItem
                    className={classes.listitem}
                    component={Link}
                    to='/orgEval'
                    button
                    onClick={()=> {
                      this.toggleDrawer('orgEval')
                    }}
                  >
                    <div className={classes.iconBorder}>
                      <ListItemIcon classes={{ root: classes.menuIcons }}>
                        <IorgEval />
                      </ListItemIcon>
                    </div>
                    <ListItemText
                      classes={{ primary: classes.listtext, inset: classes.inset }}
                      inset
                      primary='Rate Leadership Development'
                    />
                  </ListItem>

                  <ListItem
                    className={classes.listitem}
                    component={Link}
                    to='/orgStats'
                    button
                    onClick={()=> {
                      this.toggleDrawer('orgStats')
                    }}
                  >
                    <div className={classes.iconBorder}>
                      <ListItemIcon classes={{ root: classes.menuIcons }}>
                        <IorgStats />
                      </ListItemIcon>
                    </div>
                    <ListItemText
                      classes={{ primary: classes.listtext, inset: classes.inset }}
                      inset
                      primary='Leadership Dev Assessment Results'
                    />
                  </ListItem>

                  <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/genEval'
                  button
                  onClick={()=> {
                    this.toggleDrawer('genEval')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <IgenEval />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Collective Assessment'
                  />
                </ListItem>

                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/genStats'
                  button
                  onClick={()=> {
                    this.toggleDrawer('genStats')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <IgenStats />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Collective Assessment Results'
                  />
                </ListItem> */}
               {/* //////////////////////////// */}

                  {this.props.userdata &&
                   IS_COMPANY_ADMIN[this.props.userdata.userType] ? (
                        <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/getmembers'
                        button
                        onClick={()=> {
                          this.toggleDrawer('getmembers')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <InsertChart />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='getmembers'
                        />
                      </ListItem>
                    ) : null}

                  {this.props.userdata &&
                   IS_COMPANY_ADMIN[this.props.userdata.userType] ? (
                        <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/teststats'
                        button
                        onClick={()=> {
                          this.toggleDrawer('teststats')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <InsertChart />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='Tests Stats'
                        />
                      </ListItem>
                    ) : null}

                  {this.props.userdata &&
                   IS_COMPANY_ADMIN[this.props.userdata.userType] ? (
                        <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/Agentlist'
                        button
                        onClick={()=> {
                          this.toggleDrawer('Agentlist')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <InsertChart />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='Agent Participation'
                        />
                      </ListItem>
                    ) : null}

                  {this.props.userdata &&
                   IS_SCHOOL_ADMIN[this.props.userdata.userType] ? (
                        <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/SafeguardingDashboard'
                        button
                        onClick={()=> {
                          this.toggleDrawer('safeguarding')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <InsertChart />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='Safeguarding Students'
                        />
                      </ListItem>
                    ) : null}

                  {this.props.userdata &&
                   IS_COMPANY_ADMIN[this.props.userdata.userType] ? (
                        <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/MyCertificates'
                        button
                        onClick={()=> {
                          this.toggleDrawer('MyCertificates')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <InsertChart />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='Certificates'
                        />
                      </ListItem>
                    ) : null}

                   {this.props.userdata && cosignAdmin ? (  
                        <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/ExecutiveMembersTable'
                        button
                        onClick={()=> {
                          this.toggleDrawer('ExecutiveMembersTable')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <InsertChart />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='Total Member Lc'
                        />
                      </ListItem>
                    ) : null}
                {this.props.userdata && cosignAdmin ? (                  
                        <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/BlacklistTable'
                        button
                        onClick={()=> {
                          this.toggleDrawer('BlacklistTable')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <InsertChart />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='BlacklistTable'
                        />
                      </ListItem>
                    ) : null}

                   {this.props.userdata && cosignAdmin ? (                    
                      <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/admin/lc-settings'
                        button
                        onClick={()=> {
                          this.toggleDrawer('lcsettings')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <InsertChart />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='LC Settings'
                        />
                      </ListItem>
                    ) : null}

                  {this.props.userdata && cosignAdmin ? ( 
                      <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/admin/lc-earnings'
                        button
                        onClick={()=> {
                          this.toggleDrawer('lcEarnings')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <InsertChart />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='LC Earnings Monitor'
                        />
                      </ListItem>                     
                    ) : null}

                  {/* {this.props.userdata &&
                   IS_COMPANY_ADMIN[this.props.userdata.userType] ? (
                      <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/surveys'
                        button
                        onClick={()=> {
                          this.toggleDrawer('surveys')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <InsertChart />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='Surveys'
                        />
                      </ListItem>
                    ) : null} */}

                  {this.props.userdata && this.props.userdata.superUser ? (
                    <ListItem
                      className={classes.listitem}
                      component={Link}
                      to='/companies'
                      button
                      onClick={()=> {
                        this.toggleDrawer('companies')
                      }}
                    >
                      <div className={classes.iconBorder}>
                        <ListItemIcon classes={{ root: classes.menuIcons }}>
                          <InsertChart />
                        </ListItemIcon>
                      </div>
                      <ListItemText
                        classes={{ primary: classes.listtext, inset: classes.inset }}
                        inset
                        primary='Companies'
                      />
                    </ListItem>
                  ) : null}

                  {this.props.userdata &&
                   IS_COMPANY_ADMIN_MASTER[this.props.userdata.userType] ? (
                      <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/companyadmin'
                        button
                        onClick={()=> {
                          this.toggleDrawer('companyadmin')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <Person />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{ primary: classes.listtext, inset: classes.inset }}
                          inset
                          primary='Admin'
                        />
                      </ListItem>
                    ) : null}
                </div>
              </AccordionDetails>
            </Accordion>
          </React.Fragment>
        ) : this.props.userdata && APP_TYPE === 'CORPORATE' && ACCESS_COMPANY_PROFILE_USER[this.props.userdata.userType] ? (
          <React.Fragment>
            <Accordion className={classes.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon style={{ color: '#ccbc74' }} />}
                aria-controls='panel1a-content'
                id='panel1a-header'
              >
                <Typography className={classes.subheader}>LOCAL PROFILE
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className={classes.column}>
                  <ListItem
                    className={classes.listitem}
                    component={Link}
                    to='/analytics'
                    button
                    onClick={()=> {
                      this.toggleDrawer('analytics')
                    }}
                  >
                    <div className={classes.iconBorder}>
                      <ListItemIcon classes={{ root: classes.menuIcons }}>
                        <InsertChart />
                      </ListItemIcon>
                    </div>
                    <ListItemText
                      classes={{ primary: classes.listtext, inset: classes.inset }}
                      inset
                      primary='Analytics'
                    />
                  </ListItem>

                  <ListItem
                    className={classes.listitem}
                    component={Link}
                    to='/surveys'
                    button
                    onClick={()=> {
                      this.toggleDrawer('surveys')
                    }}
                  >
                    <div className={classes.iconBorder}>
                      <ListItemIcon classes={{ root: classes.menuIcons }}>
                        <InsertChart />
                      </ListItemIcon>
                    </div>
                    <ListItemText
                      classes={{ primary: classes.listtext, inset: classes.inset }}
                      inset
                      primary='Surveys'
                    />
                  </ListItem>

                  {this.props.userdata && this.props.userdata.superUser ? (
                    <ListItem
                      className={classes.listitem}
                      component={Link}
                      to='/companies'
                      button
                      onClick={()=> {
                        this.toggleDrawer('companies')
                      }}
                    >
                      <div className={classes.iconBorder}>
                        <ListItemIcon classes={{ root: classes.menuIcons }}>
                          <InsertChart />
                        </ListItemIcon>
                      </div>
                      <ListItemText
                        classes={{ primary: classes.listtext, inset: classes.inset }}
                        inset
                        primary='Companies'
                      />
                    </ListItem>
                  ) : null}
                  {this.props.userdata &&
                   IS_COMPANY_ADMIN[this.props.userdata.userType] ? (
                      <ListItem
                        className={classes.listitem}
                        component={Link}
                        to='/companyadmin'
                        button
                        onClick={()=> {
                          this.toggleDrawer('companyadmin')
                        }}
                      >
                        <div className={classes.iconBorder}>
                          <ListItemIcon classes={{ root: classes.menuIcons }}>
                            <Person />
                          </ListItemIcon>
                        </div>
                        <ListItemText
                          classes={{
                            primary: classes.listtext,
                            inset: classes.inset
                          }}
                          inset
                          primary='Local Admin'
                        />
                      </ListItem>
                    ) : null}
                </div>
              </AccordionDetails>
            </Accordion>
          </React.Fragment>
        )
          : null
        }

        <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: '#ccbc74' }} />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <Typography className={classes.subheader}>More...</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className={classes.column}>
              {/* <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/LeaderOnList'
                  button
                  onClick={()=> {
                    this.toggleDrawer('LeaderOnList')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <LeaderboardIcon />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Leaderboard'
                  />
                </ListItem> */}
              {/* <ListItem
                    className={classes.listitem}
                    component={Link}
                    to="/Bookshop"
                    button
                    onClick={e => { this.toggleDrawer("bookshop") }}
                  >
                    <div className={classes.iconBorder}>
                      <ListItemIcon classes={{ root: classes.menuIcons }}>
                        <LibraryBooks />
                      </ListItemIcon>
                    </div>
                    <ListItemText
                      classes={{ primary: classes.listtext, inset: classes.inset }}
                      inset
                      primary="Bookshop"
                    />
                  </ListItem>   */}
              { userdata ?
                <Link
                  style={{ textDecoration: 'none', fontSize: '14px' }}
                  to={{
                    pathname: '/Poe',
                    state: {
                      Everyone: userdata.userID
                    }
                  }}
                  onClick={() => {
                    this.toggleDrawer('poe')
                  }}
                >
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<PoeIcon />
                  <font style={{
                    margin: '12px',
                    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                    color: '#676767',
                    fontSize: '14px'
                  }}>&nbsp;&nbsp;Portfolio of Evidence</font><br/> <br/>
                </Link>
                : null}

              {/* <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/poe'
                  button
                  onClick={()=> {
                    this.toggleDrawer('poe')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <PoeIcon />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Portfolio of Evidence'
                  />
                </ListItem> */}

              {userdata && ['-LgsUykfo8z1U9MXgd9', '-Lu4BlhZ-tsDSnd-fnFd'].includes(this.props.userdata.companyID) ? (null) : (
                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/tutorials'
                  button
                  onClick={()=> {
                    this.toggleDrawer('tutorials')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <HelpOutline />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Tutorials'
                  />
                </ListItem>
              )}
              {userdata && ['-LgsUykfo8z1U9MXgd9'].includes(this.props.userdata.companyID) ? (null) : (
                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/tcs'
                  button
                  onClick={()=> {
                    this.toggleDrawer('tcs')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <PlaylistAddCheck />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Terms & Conditions'
                  />
                </ListItem>
              )}
              {/* {isBrowser ?
                <ListItem
                  className={classes.listitem}
                  // component={Link}
                  // to="/tcs"
                  button
                  onClick={() => this.setDownload()}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <Downloadapp />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Download Desktop App'
                  />
                </ListItem>
                : null} */}
                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/wallet'
                  button
                  onClick={()=> {
                    this.toggleDrawer('wallet')
                  }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <PlaylistAddCheck />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='MeVision Coin'
                  />
                </ListItem>
                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/liqA'
                  button
                  // onClick={()=> {
                  //   this.toggleDrawer('wallet')
                  // }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <PlaylistAddCheck />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Patrons: Important'
                  />
                </ListItem>
                <ListItem
                  className={classes.listitem}
                  component={Link}
                  to='/liqB'
                  button
                  // onClick={()=> {
                  //   this.toggleDrawer('wallet')
                  // }}
                >
                  <div className={classes.iconBorder}>
                    <ListItemIcon classes={{ root: classes.menuIcons }}>
                      <PlaylistAddCheck />
                    </ListItemIcon>
                  </div>
                  <ListItemText
                    classes={{ primary: classes.listtext, inset: classes.inset }}
                    inset
                    primary='Liquidity: What is it?'
                  />
                </ListItem>
            </div>
          </AccordionDetails>
        </Accordion>

        <List
          component='nav'
          subheader={
            <ListSubheader className={classes.subheader} component='div' />
          }
          className={classes.root}
        >
          <ListItem
            className={classes.listitem}
            component={Link}
            to='/'
            //state={{ repp: false }}
            // divider={true}
            // key={'aaa'}
            //to={page==='ilead' ? '/' : '/ilead'}

            render={(props) => <Gotopatreon rep={false} {...props} />}
            //state={{ contact: 'aaa' }}
            button
            onClick={this.props.signOutStrong}
          >
            <div className={classes.iconBorder}>
              <ListItemIcon classes={{ root: classes.menuIcons }}>
                <ExitToApp style={{ color: '#ccbc74' }} />
              </ListItemIcon>
            </div>
            <ListItemText
              classes={{ primary: classes.listExec, inset: classes.inset }}
              inset
              primary='Sign Out'
            />
          </ListItem>
        </List>
      </div>
    )

    return (
      <React.Fragment>
        <div className={classes.root}>
          {this.state.showDownloadNote ? <DownloadNote key={Math.random()} /> : null}

          <CssBaseline />
          {drawer}
        </div>
      </React.Fragment>
    )
  }
}
SideBar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
}

// const hoverActive = {
//   "&.active": {
//     "& path": {
//       color: "red"
//     }
//   },
//   "&:hover, &.active:hover": {
//     "& path": {
//       color: "red"
//     }
//   }
// };


const SideBarModule = withStyles(styles, { withTheme: true })(SideBar)

const mapStateToProps = state => {
  return {
    unseenotifications: state.userdata.unseenotifications,
    unseengroupnotifications: state.userdata.unseengroupnotifications,
    unseenpldpnotifications: state.userdata.unseenpldpnotifications,
    speedDPath: state.speedDialP.speedDPath,
    userdata: state.userDialog.userDetails[0] || null,
    leaderboardData: state.users.leaderboardData,
    loadingLBLeaders: state.loadingLeaders.leaderboardloading
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    signOut: () => dispatch(signOut()),
    signOutStrong: () => dispatch(signOutStrong()),
    signOutDuplicate: () => dispatch(signOutDuplicate()),
    captureUserActivity: params => dispatch(captureUserActivity(params)),
    showSpeedDial: params => dispatch(showSpeedDial(params)),
    getAllCompanyLeaders: params => dispatch(getAllCompanyLeaders(params)),
    loadingAction: params => dispatch(loadingAction(params)),
    CgetOpinions: params => dispatch(CgetOpinions(params)),
    GgetOpinions: params => dispatch(GgetOpinions(params)),
    getOpinions: params => dispatch(getOpinions(params)),
    showToast: (params) => dispatch(showToast(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SideBarModule)
